const LETTERS = 'abcdefghijklmnopqrstuvwxyz';

// The number each row carries comes from its place in the list. A whole category takes its
// position; a sub-part takes its parent's number and a letter, so two sub-parts read 4a and 4b.
// The school's EHCP category reads 0 and comes first, as on the local authority allocation lists.
export const resolveNumbers = rows => {
    const numbers = [];
    let category = rows[0]?.isEhcp ? -1 : 0;
    let subPart = 0;

    rows.forEach(row => {
        if (row.isSubPart && category > 0) {
            numbers.push(`${category}${LETTERS[subPart] ?? `.${subPart + 1}`}`);
            subPart += 1;
            return;
        }

        category += 1;
        subPart = 0;
        numbers.push(`${category}`);
    });

    return numbers;
};

// The EHCP category always comes first and is a category of its own. The row under it cannot be a
// part of it, and the first row can never be a sub-part.
export const normaliseRows = next => {
    const ehcp = next.filter(row => row.isEhcp);
    const ordered = [...ehcp, ...next.filter(row => !row.isEhcp)];
    const firstOrdinary = ehcp.length;

    return ordered.map((row, index) => ({
        ...row,
        isSubPart: row.isEhcp || index <= firstOrdinary ? false : row.isSubPart
    }));
};

// Ticking EHCP on one category takes it off any other.
export const markEhcp = (rows, target, isEhcp) =>
    normaliseRows(rows.map(row => ({...row, isEhcp: row === target ? isEhcp : (isEhcp ? false : row.isEhcp)})));
